import { render } from "./ReportCustomAlert.vue?vue&type=template&id=1bc55ae6"
import script from "./ReportCustomAlert.vue?vue&type=script&lang=js"
export * from "./ReportCustomAlert.vue?vue&type=script&lang=js"
script.render = render

export default script